module.exports = __webpack_public_path__ + "img/img_teacher5.7432725e.png";